import {getBrand} from '.';

import {getCurrentLang} from '../utils/i18n';
import store from '../store';

export const analyticsTrackAction = (action, extra) => {
    const user = store.getState().user;
    const idp = user?.ipd;
    const brand = getBrand();

    window.turner_metadata.trackAction.push({
        type: 'interaction',
        data: {
            interaction: action,
            pageName:
                (brand === 'cnapp' ? 'cnplus.com' : window.location.host) +
                window.location.pathname,
            domain:
                brand === 'cnito'
                    ? 'cartoonito.com'
                    : brand === 'cnapp'
                    ? 'cnplus.com'
                    : 'discoverykids.com',
            brand:
                brand === 'cnito'
                    ? 'cartoonito'
                    : brand === 'cnapp'
                    ? 'cartoon network'
                    : 'discovery kids',
            platform: 'web',
            region: 'latam',
            country:
                user && user.countryIsoCode && user.countryName
                    ? `${user.countryIsoCode.toLowerCase()}|${user.countryName}`
                    : 'not loaded',
            interactionevent: '1',
            authstate:
                user && user.jwtToken ? 'authenticated' : 'unauthenticated',
            mvpd: idp || 'idp not loaded',
            userlang: getCurrentLang(),
            ...extra,
        },
    });
};

export const analyticsTrackState = (pageName, extra) => {
    const user = store.getState().user;
    const idp = user?.ipd;
    const brand = getBrand();
    const stateBrand = brand === 'cnapp' ? 'cnplus.com' : `cnplus.com/${brand}`;

    window.turner_metadata.trackAction.push({
        type: 'pageview',
        data: {
            pageName: `${stateBrand}/${pageName}`,
            presentationtemplate: 'desktop',
            platform: 'web',
            domain: window.location.host,
            region: 'latam',
            country:
                user && user.countryIsoCode && user.countryName
                    ? `${user.countryIsoCode.toLowerCase()}|${user.countryName}`
                    : 'not loaded',
            brand: stateBrand,
            pageviewevent: 1,
            authstate:
                user && user.jwtToken ? 'authenticated' : 'unauthenticated',
            mvpd: idp || 'idp not loaded',
        },
    });
};

export const trackVHLEvent = (event, extra, content, isLive, title) => {
    const user = store.getState().user;
    const idp = user?.ipd;

    window.turner_metadata.trackAction.push({
        type: 'video',
        subtype: event,
        data: {
            platform: 'web',
            content_name: title,
            content_id: content.id,
            content_type: isLive ? 'live' : 'vod',

            authstate:
                user && user.jwtToken ? 'authenticated' : 'unauthenticated',
            mvpd: idp || 'idp not loaded',
            logintype: user.user_type,
            ...extra,
        },
    });
};
